export function TrendLineDown(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.456 8.53344V6.45257C11.456 6.1944 11.2386 5.986 10.9693 5.986C10.7 5.986 10.4826 6.1944 10.4826 6.45257V7.44635L7.28668 4.38258C7.10336 4.20684 6.78052 4.20684 6.59721 4.38258L4.63748 6.26128L1.3783 3.13686C1.28258 3.0451 1.15767 3 1.03437 3C0.909457 3 0.784541 3.0451 0.690448 3.13686C0.499017 3.31882 0.499017 3.61431 0.690448 3.79627L4.29355 7.25194C4.47525 7.42613 4.79971 7.42613 4.98141 7.25194L6.94113 5.37169L9.75256 8.06687H8.79865C8.53098 8.06687 8.31197 8.27527 8.31197 8.53344C8.31197 8.7916 8.53098 9 8.79865 9H10.9693C11.2386 9 11.456 8.7916 11.456 8.53344Z"
        fill="#FB3748"
      />
    </svg>
  );
}
